import { Actions } from './constants';
import { ActionsType, User } from './types';
import { Reducer } from 'redux';
import { State } from 'src/redux/types';
import { Resources } from 'src/types';

const initialState: State<User> = {
  list: [],
  userData: {},
  isLoading: false,
  error: undefined,
  isSuccess: false,
  snackBarResource: Resources.Usuarios,
};

const userReducer: Reducer<State<User>, ActionsType> = (
  state = initialState,
  action,
): State<User> => {
  switch (action.type) {
    case Actions.GET_USERS_PENDING:
      return {
        ...state,
        isLoading: true,
      };
    case Actions.GET_USERS_SUCCESS:
      return {
        ...state,
        list: action.payload,
        isLoading: false,
      };
    case Actions.GET_USERS_ERROR:
      return {
        ...state,
        isLoading: false,
        error: { ...action.payload },
      };
    case Actions.GET_USER_BY_UID_PENDING:
      return {
        ...state,
        isLoading: true,
      };
    case Actions.GET_USER_BY_UID_SUCCESS:
      return {
        ...state,
        userData: action.payload,
        isLoading: false,
      };
    case Actions.GET_USER_BY_UID_ERROR:
      return {
        ...state,
        isLoading: false,
        error: { ...action.payload },
      };
    case Actions.ADD_USER_PENDING:
      return {
        ...state,
        isLoading: true,
      };
    case Actions.ADD_USER_SUCCESS:
      return {
        ...state,
        list: [...state.list, action.payload],
        isLoading: false,
        error: undefined,
        isSuccess: true,
        snackBarResource: Resources.Usuarios,
      };
    case Actions.ADD_USER_ERROR:
      return {
        ...state,
        isLoading: false,
        error: { ...action.payload },
        snackBarResource: Resources.Usuarios,
        isSuccess: false,
      };
    case Actions.ADD_USER_FROM_CSV_PENDING:
      return {
        ...state,
        isLoading: true,
      };
    case Actions.ADD_USER_FROM_CSV_SUCCESS:
      return {
        ...state,
        list: [...state.list, ...action.payload],
        isLoading: false,
        isSuccess: true,
        error: undefined,
      };
    case Actions.ADD_USER_FROM_CSV_ERROR:
      return {
        ...state,
        isLoading: false,
        error: { ...action.payload },
      };
    case Actions.EDIT_USER_PENDING:
      return {
        ...state,
        isLoading: true,
      };
    case Actions.EDIT_USER_SUCCESS:
      return {
        ...state,
        list: state.list.map((item) => {
          if (item._id === action.payload.id) {
            return { ...action.payload.response };
          }
          return item;
        }),
        userData: action.payload.response,
        isLoading: false,
        error: undefined,
        isSuccess: true,
      };
    case Actions.EDIT_USER_ERROR:
      return {
        ...state,
        isLoading: false,
        error: { ...action.payload },
        isSuccess: false,
      };
    case Actions.DELETE_USER_PENDING:
      return {
        ...state,
        isLoading: true,
      };
    case Actions.DELETE_USER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        list: state.list.map((user) => {
          if (user._id === action.payload) {
            return {
              ...user,
              isActive: false,
            };
          }
          return user;
        }),
        error: undefined,
        snackBarResource: Resources.Usuarios,
      };
    case Actions.DELETE_USER_ERROR:
      return {
        ...state,
        error: { ...action.payload },
        isLoading: false,
      };
    case Actions.CLEAN_USER_ERROR:
      return {
        ...state,
        error: undefined,
      };
    case Actions.HANDLE_SUCCESS:
      return {
        ...state,
        isSuccess: false,
      };
    case Actions.SET_RESOURCE_NAME:
      return {
        ...state,
        snackBarResource: action.payload,
      };
    default:
      return state;
  }
};

export default userReducer;
